import axios from "axios";
import { APP_URL } from "../../../config/api";
import { errorMessage } from "../../errorHandle";

export const getUserListForAssignCourse = () => {
  return (dispatch) => {
    dispatch({
      type: ASSINGCOURSE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-lp-or-org-users`,
      })
      .then((res) => {
        dispatch({
          type: ASSINGCOURSE.GET_USER_LIST,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSINGCOURSE.ERROR));
      });
  };
};

export const addAssignCourseToUser = (prm) => {
  return (dispatch) => {
    dispatch({
      type: ASSINGCOURSE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/assign-course-to-user`,
        data: prm,
      })
      .then((res) => {
        dispatch({
          type: ASSINGCOURSE.ASSING_COURSE_TO_USER,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSINGCOURSE.ERROR));
      });
  };
};

export const getAssignedCourseUserList = (prm) => {
  return (dispatch) => {
    dispatch({
      type: ASSINGCOURSE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-course-users-list`,
        data: prm,
      })
      .then((res) => {
        dispatch({
          type: ASSINGCOURSE.GET_ASSIGN_COURSE_USER_LIST,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSINGCOURSE.ERROR));
      });
  };
};

export const getAssignUserCoureseList = () => {
  return (dispatch) => {
    dispatch({
      type: ASSINGCOURSE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-user-courses`,
      })
      .then((res) => {          
        dispatch({
          type: ASSINGCOURSE.GET_ASSING_USER_COURSE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSINGCOURSE.ERROR));
      });
  };
};


const TAG = "ASSING_COURSE_";

export const ASSINGCOURSE = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  GET_USER_LIST: TAG + "GET_USER_LIST",
  GET_ASSIGN_COURSE_USER_LIST: TAG + "GET_ASSIGN_COURSE_USER_LIST",
  ASSING_COURSE_TO_USER: TAG + "ASSING_COURSE_TO_USER",
  GET_ASSING_USER_COURSE: TAG + "GET_ASSING_USER_COURSE",
  START_USER_COURSE: TAG + "START_USER_COURSE",
};
